/**
 * Browser Location Utility Service
 * 
 * Abstracts browser-specific location APIs for improved testability and SSR compatibility.
 * This service can be easily mocked in tests and isolates browser-dependent code.
 */

/**
 * Gets the current hostname
 * @returns {string} The hostname (e.g., 'www.verizon.com')
 */
export const getHostname = () => {
  if (typeof window !== 'undefined' && window.location) {
    return window.location.hostname;
  }
  return '';
};

/**
 * Gets the current host (hostname + port)
 * @returns {string} The host (e.g., 'www.verizon.com:8080')
 */
export const getHost = () => {
  if (typeof window !== 'undefined' && window.location) {
    return window.location.host;
  }
  return '';
};

/**
 * Gets the current origin (protocol + hostname + port)
 * @returns {string} The origin (e.g., 'https://www.verizon.com')
 */
export const getOrigin = () => {
  if (typeof window !== 'undefined' && window.location) {
    return window.location.origin;
  }
  return '';
};

/**
 * Navigates to a full URL (external or full page reload)
 * @param {string} url - The URL to navigate to
 */
export const navigateToUrl = (url) => {
  if (typeof window !== 'undefined' && window.location) {
    window.location.href = url;
  }
};

/**
 * Builds a sign-in URL with proper environment detection
 * @param {string} gotoUrl - The URL to redirect to after sign-in
 * @returns {string} The complete sign-in URL
 */
export const buildSignInUrl = (gotoUrl) => {
  const hostname = getHostname();
  let baseSignInUrl = 'https://secure.verizon.com/signin';
  
  // Detect QA environment
  if (hostname.indexOf('.verizonwireless.com') > -1) {
    const host = getHost();
    const qaEnv = host.split('.');
    const number = qaEnv?.[0]?.match(/(\d+)/);
    if (number && number[0]) {
      baseSignInUrl = `https://securesit${number[0]}.verizon.com/signin`;
    }
  }
  
  return `${baseSignInUrl}?goto=${gotoUrl}`;
};
